import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({ text, _callback, boo, setModal }) {
  return (
    <div>
      <Dialog
        open={boo}
        onClose={() => {
          setModal(false);
          _callback(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Внимание</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setModal(false);
              _callback(false);
            }}
          >
            нет
          </Button>
          <Button
            onClick={() => {
              setModal(false);
              _callback(true);
            }}
            autoFocus
          >
            да
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
